import Papa from "papaparse";
import type { TFunction } from "i18next";
import { errorToast } from "../../utils/toasts";
import type { ValidationItem } from "./alertUtils";

// Pattern B (i18n): caller passes their bound `t`. The caller's
// `useTranslation([...])` must include `"uploads"` (primary or secondary) so
// selectors like `$.download.Errors` resolve.
export function downloadBulkUploadErrorsAndWarnings(
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  t: TFunction<any, any>,
  errors: ValidationItem[],
  warnings: ValidationItem[],
  fileNamePrefix = "upload_alerts_",
) {
  try {
    const rows: string[][] = [];

    if (errors.length > 0) {
      rows.push([t(($) => $.uploads.download.Errors)]);
      rows.push([
        t(($) => $.uploads.download.Row),
        t(($) => $.uploads.download.Field),
        t(($) => $.uploads.download.Message),
      ]);
      errors.forEach((error) => {
        rows.push([error.row === null ? "—" : `#${error.row + 1}`, error.field, error.message]);
      });
      rows.push([]);
    }

    if (warnings.length > 0) {
      rows.push([t(($) => $.uploads.download.Warnings)]);
      rows.push([
        t(($) => $.uploads.download.Row),
        t(($) => $.uploads.download.Field),
        t(($) => $.uploads.download.Message),
      ]);
      warnings.forEach((warning) => {
        rows.push([warning.row === null ? "—" : `#${warning.row + 1}`, warning.field, warning.message]);
      });
    }

    const csvContent = Papa.unparse(rows);
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const timestamp = new Date().toISOString().replaceAll(/[:.]/g, "-").slice(0, 19);
    link.download = `${fileNamePrefix}${timestamp}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    errorToast({
      message: t(($) => $.uploads.toasts["Failed to download the error report. Please try again."]),
      error,
    });
  }
}
